import React, { useState } from "react";

function Multiple_images({collection}) {
  const [selectedImages, setSelectedImages] = useState([]); // Base64 previews
  const [files, setFiles] = useState([]); // Actual File objects
  const [loading, setLoading] = useState(false);

  // Column names in same order as inputs
  const fieldNames = [
    "front_ID",
    "Result_slip",
    "Result_slip_2",
    "Result_slip_3"
  ];

  // handle image selection
  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImages = [...selectedImages];
        const newFiles = [...files];

        newImages[index] = reader.result;
        newFiles[index] = file;

        setSelectedImages(newImages);
        setFiles(newFiles);
      };
      reader.readAsDataURL(file);
    }
  };

  // handle upload
  const handleSubmit = async (e) => {
    e.preventDefault();
    if(files.length < 1)
   {
      alert('select images')
      return
   }
    setLoading(true);

    try {
      for (let i = 0; i < files.length; i++) {
        if (!files[i]) continue;

        const formData = new FormData();
        formData.append("image", files[i]);
        formData.append("field", fieldNames[i]);
        formData.append("unik", collection.timestamp); // replace with your actual ID

        const res = await fetch(
          "https://hosteladventures.site/PHP/Opportunites/Scholarship/Photos_upload_test.php",
          {
            method: "POST",
            body: formData,
          }
        );

        const data = await res.json();
        console.log("Upload response:", data);
      }

      alert('Thak you for the application, we whish you the best of luck')
      collection.setScholarship(false)
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed!");
    }

    setLoading(false);
  };

  return (
    <div className="property_doc_Inner">
      <form onSubmit={handleSubmit}>
        <div className="docs_multiple">
          
          {/* FRONT ID IMAGE */}
          <div className="img_Disp_multuple">
            <img src={selectedImages[0]} alt="" />
            <div className="label_DIV">
              <label htmlFor="file-upload-1" className="img_label_multiple">
                Click to choose front ID pic
              </label>
            </div>
            <input
              id="file-upload-1"
              className="choose_img"
              accept="image/jpeg, image/jpg"
              type="file"
              onChange={(e) => handleImageChange(e, 0)}
            />
          </div>

          {/* RESULT SLIP 1 */}
          <div className="img_Disp_multuple">
            <img src={selectedImages[1]} alt="" />
            <div className="label_DIV">
              <label htmlFor="file-upload-2" className="img_label_multiple">
                Click to choose Results Slip Image
              </label>
            </div>
            <input
              id="file-upload-2"
              className="choose_img"
              accept="image/jpeg, image/jpg"
              type="file"
              onChange={(e) => handleImageChange(e, 1)}
            />
          </div>

          {/* RESULT SLIP 2 */}
          <div className="img_Disp_multuple">
            <img src={selectedImages[2]} alt="" />
            <div className="label_DIV">
              <label htmlFor="file-upload-3" className="img_label_multiple">
                Click to choose second Results Slip Image (optional)
              </label>
            </div>
            <input
              id="file-upload-3"
              className="choose_img"
              accept="image/jpeg, image/jpg"
              type="file"
              onChange={(e) => handleImageChange(e, 2)}
            />
          </div>

          {/* RESULT SLIP 3 */}
          <div className="img_Disp_multuple">
            <img src={selectedImages[3]} alt="" />
            <div className="label_DIV">
              <label htmlFor="file-upload-4" className="img_label_multiple">
                Click to choose third Results Slip Image (optional)
              </label>
            </div>
            <input
              id="file-upload-4"
              className="choose_img"
              accept="image/jpeg, image/jpg"
              type="file"
              onChange={(e) => handleImageChange(e, 3)}
            />
          </div>
        </div>

        <button type="submit" className="submit" disabled={loading}>
          {loading ? "Uploading..." : "Submit"}
        </button>
      </form>
    </div>
  );
}

export default Multiple_images;
